import React, { useState } from 'react';
import styles from './Login.module.css';
// Import Material Icons
import AnalyticsIcon from '@mui/icons-material/Analytics'; // Icon for logo
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import LockOutlineIcon from '@mui/icons-material/LockOutline';

const Login: React.FC<{ onLogin: () => void }> = ({ onLogin }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    // Hardcoded credentials from the image
    const validUsername = 'admin';
    const validPassword = 'password123';

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        
        if (username === validUsername && password === validPassword) {
            onLogin();
        } else {
            setError('Invalid username or password');
        }
    };

    // Function to prefill login details
    const handlePrefill = () => {
        setUsername(validUsername);
        setPassword(validPassword);
        setError(''); // Clear any previous error message
    };

    return (
        <div className={styles.loginContainer}>
            <div className={styles.logo}>
                <AnalyticsIcon className={styles.logoIcon} /> {/* Use Icon */} 
                <span>JuzBI</span> {/* Keep text separate */} 
            </div>
            <div className={styles.loginBox}>
                <h2>Sign in to your account</h2>
                <form onSubmit={handleSubmit}>
                    <div className={styles.formGroup}>
                        <label htmlFor="username">Username</label>
                        <div className={styles.inputWrapper}>
                            <PersonOutlineIcon className={styles.inputIcon} />
                            <input
                                type="text"
                                id="username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                                placeholder="admin"
                            />
                        </div>
                    </div>
                    <div className={styles.formGroup}>
                        <label htmlFor="password">Password</label>
                        <div className={styles.inputWrapper}>
                            <LockOutlineIcon className={styles.inputIcon} />
                            <input
                                type="password"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                placeholder="••••••••••••"
                            />
                        </div>
                    </div>
                    {error && <div className={styles.error}>{error}</div>}
                    <button type="submit" className={styles.loginButton}>
                        Sign in
                    </button>
                </form>
                <div className={styles.demoCredentials}>
                    <div className={styles.demoHeader}>
                         <p>Demo Credentials</p>
                         <button onClick={handlePrefill} className={styles.prefillButton}>
                            Prefill
                        </button>
                    </div>
                    <div className={styles.demoInfo}>
                         <strong>Demo Account</strong>
                        <span>Username: {validUsername}</span>
                        <span>Password: {validPassword}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login; 